import React, { useEffect, useRef, useState } from "react";
import "./login.css";
import subLogo from "../../assets/forgot-password-logo1.png";
import asscentsLogo from "../../assets/asscentsLogo.png";
import { Field, Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import ErrorMsg from "../../components/form/errorMsg";
import * as authActions from "../../redux/actions/authActions";
import { useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";
import ChangeSaved from "../../components/popups/ChangeSaved";
import ErrorPopup from "../../components/popups/ErrorPopup";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(true);
  const formRef = useRef();
  const [submitDisable, setSubmitDisable] = useState(false);
  const [data, setData] = useState("");
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showErrorPopup1, setShowErrorPopup1] = useState(false);
  const [showErrorMsg1, setShowErrorMsg1] = useState("");


  const initialValues = {
    email: ""
  };

  const loginSchema = Yup.object().shape({
    email: Yup.string().required("Required")
  });

  const onSubmit = (values, { resetForm }) => {
    console.log(values);
    setSubmitDisable(true);

    dispatch(
      authActions.ForgotPassword(values, onSuccess, onError)
    );
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    setData(data);
    setSubmitDisable(false);
    navigate("/password-mail-sent");
  }

  const onSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = (data.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  }

  const closeErrorPopup1 = () => {
    setShowErrorPopup1(false);
  }

  const onError = (data, message) => {
    setSubmitDisable(false);
    formRef?.current?.setFieldError("email", data?.errors?.email);
    if (message) {
      setShowErrorPopup(true);
      const str = (message);
      const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
      setShowErrorMsg(str_modify);
    } else setShowErrorPopup1(true);
    const str1 = (data.data.message);
    const str_modify1 = str1.charAt(0).toUpperCase() + str1.slice(1);
    setShowErrorMsg1(str_modify1);
  };
  
  const FormEnableCheck = () => {
    const {
      values: { email },
    } = useFormikContext();
    useEffect(() => {
      if (email.trim() != "") {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }, [email]);
    return null;
  };

  return (
    <div className="login-container fn_Nunito d-flex flex-column flex-lg-row justify-content-center ">
      <div className="mt-">
        <img
          src={asscentsLogo}
          alt="website logo"
          className="login-logo-image d-lg-none"
        />
      </div>
      <div className="left-view  d-flex flex-column  justify-content-center mt-3 mt-lg-0">
        <img
          src={subLogo}
          alt="Asscents Website"
          className="login-img align-self-center"
        />
      </div>
      <div className="right-view justify-content-center d-flex flex-column mt-5 pt-3 pt-lg-0 mt-lg-0">
        <div className="form-container col-12 col-lg-7 align-self-center d-flex justify-content-around  flex-column">
          <img
            src={asscentsLogo}
            alt="website logo"
            className="login-logo-image d-none d-lg-block"
          />
          <Formik
            initialValues={initialValues}
            validationSchema={loginSchema}
            onSubmit={onSubmit}
            innerRef={formRef}
          >
            {({ setFieldValue, values, setFieldError }) => (
              <Form>
                <FormEnableCheck />
                <h1 className="fw_700 fs_22 text-center text-lg-start">
                  Forgot Password
                </h1>
                <div className=" mt-3">
                  <label className="w-100 mx-1 label-input color_262c3d">
                    Email Address
                  </label>
                  <Field name={"email"}>
                    {({ field, meta }) => (
                      <input
                        {...field}
                        placeholder="Enter your email address"
                        id={"email"}
                        className={"col-12 input-field"}
                      />
                    )}
                  </Field>
                  <ErrorMsg name="email" />
                </div>
                <button
                  className={`login-button`}
                  type="submit"
                  disabled={disable || submitDisable}
                >
                  {submitDisable && <Spinner size="sm" />} Get Reset link
                </button>
                <p className="color_747f9e text-center fs_14">Do you know your password? &nbsp;
                  <span onClick={() => navigate("/")} className="span-support cursor_pointer text-nowrap fw_600 fs_14 pe-1">
                    Login</span></p>
              </Form>
            )}
          </Formik>
          <ChangeSaved
            show={onSuccessShow}
            title={onSuccessMsg}
          />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
          <ErrorPopup
            show={showErrorPopup1}
            title={showErrorMsg1}
            handleClose={closeErrorPopup1}
          />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

